import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Offcanvas } from "react-bootstrap";
import { FaPhone, FaBars } from "react-icons/fa";
import logo1 from "../assets/logo1.png";
import logo2 from "../assets/logo2.png";
import { colors } from "../utils/Colors";

const Header = ({ scrollFunctions = {} }) => {
    const [show, setShow] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [headerOpacity, setHeaderOpacity] = useState(0);
    const [blurAmount, setBlurAmount] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
        
            const opacity = Math.min(scrollPosition / 50, 1);
            setHeaderOpacity(opacity);

            const blur = Math.min(scrollPosition / 100, 8); 
            setBlurAmount(blur);
            
          
            setIsScrolled(scrollPosition > 10);
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    const handleNavClick = (section) => {
        handleClose(); 
        
        switch(section) {
            case 'home':
                scrollFunctions.scrollToHome?.();
                break;
            case 'about':
                scrollFunctions.scrollToAbout?.();
                break;
            case 'menus':
                scrollFunctions.scrollToMenus?.();
                break;
            case 'gallery':
                scrollFunctions.scrollToGallery?.();
                break;
            case 'contact':
                scrollFunctions.scrollToContact?.();
                break;
            case 'book-now':
                scrollFunctions.scrollToBookNow?.();
                break;
            default:
                break;
        }
    };


    const navItems = [
        { id: 'home', label: 'Home' },
        { id: 'about', label: 'About Us' },
        { id: 'menus', label: 'Menus' },
        { id: 'gallery', label: 'Gallery' },
        { id: 'contact', label: 'Contact Us' },
        { id: 'book-now', label: 'Book Now' }
    ];

    return (
        <>
            
            <div className="top-header" style={{
                backgroundColor: `rgba(51, 51, 51, ${0.9 - (headerOpacity * 0.4)})`,
                color: 'white',
                padding: '8px 0',
                backdropFilter: `blur(${blurAmount * 0.5}px)`,
                WebkitBackdropFilter: `blur(${blurAmount * 0.5}px)`,
                position: 'fixed',
                top: 0,
                width: '100%',
                zIndex: 1030,
                transition: 'all 0.3s ease',
                transform: isScrolled ? 'translateY(-100%)' : 'translateY(0)',
                opacity: isScrolled ? 0 : 1,
                height: isScrolled ? 0 : 'auto'
            }}>
                <Container className="d-flex justify-content-between align-items-center">
                    <div className="d-none d-md-block">
                        <span style={{ fontSize: '14px' }}>
                            <FaPhone className="me-2" />
                            Manager: 0315-5530667
                        </span>
                    </div>
                    <div className="text-center flex-grow-1">
                        <span style={{ fontSize: '14px' }}>
                            Opening Hours: Mon-Sun 9:00 AM - 11:00 PM
                        </span>
                    </div>
                    <div className="d-none d-md-block">
                        <span style={{ fontSize: '14px' }}>
                            <FaPhone className="me-2" />
                            Support: 0332-9911223
                        </span>
                    </div>
                </Container>
            </div>

            
            <Navbar 
                expand="lg" 
                variant="dark" 
                fixed="top"
                style={{ 
                    backgroundColor: `rgba(51, 51, 51, ${0.9 - (headerOpacity * 0.3)})`,
                    backdropFilter: `blur(${blurAmount}px) saturate(180%)`,
                    WebkitBackdropFilter: `blur(${blurAmount}px) saturate(180%)`,
                    padding: isScrolled ? '10px 0' : '15px 0',
                    transition: 'all 0.3s ease',
                    boxShadow: isScrolled 
                        ? `0 10px 30px rgba(0, 0, 0, ${0.2 + (headerOpacity * 0.3)})`
                        : 'none',
                    borderBottom: `1px solid rgba(255, 255, 255, ${0.1 * (1 - headerOpacity)})`,
                    marginTop: isScrolled ? 0 : '40px',
                }}
                className={`main-navbar ${isScrolled ? 'scrolled' : ''}`}
            >
                <Container>
                   
                    <button 
                        className="d-lg-none border-0 bg-transparent text-white"
                        onClick={handleShow}
                        style={{ 
                            fontSize: '24px',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <FaBars />
                    </button>

                    <div className="d-none d-lg-block" style={{
                        transition: 'all 0.3s ease',
                        transform: isScrolled ? 'scale(0.9)' : 'scale(1)'
                    }}>
                        <img src={logo2} alt="Logo" height={isScrolled ? "35" : "40"} />
                    </div>

                    <Nav className="mx-auto gap-4 d-none d-lg-flex">
                        {navItems.map((item) => (
                            <Nav.Link 
                                key={item.id}
                                onClick={() => handleNavClick(item.id)}
                                style={{ 
                                    color: 'white', 
                                    fontWeight: '500',
                                    fontSize: isScrolled ? '15px' : '16px',
                                    padding: '10px 0',
                                    position: 'relative',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                                className="nav-link-hover"
                            >
                                {item.label}
                                <span className="nav-underline" style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    width: '0%',
                                    height: '2px',
                                    backgroundColor: colors.SECONDARY,
                                    transition: 'width 0.3s ease',
                                    transform: 'translateY(5px)'
                                }} />
                            </Nav.Link>
                        ))}
                    </Nav>

                
                    <div className="d-none d-lg-block" style={{
                        transition: 'all 0.3s ease',
                        transform: isScrolled ? 'scale(0.9)' : 'scale(1)'
                    }}>
                        <img src={logo1} alt="Logo" height={isScrolled ? "35" : "40"} />
                    </div>

                  
                    <div className="d-lg-none mx-auto">
                        <img src={logo1} alt="Logo" height={isScrolled ? "35" : "40"} />
                    </div>
                </Container>
            </Navbar>

          
            <div style={{ 
                height: isScrolled ? '70px' : '110px',
                transition: 'height 0.3s ease'
            }} />

          
            <Offcanvas 
                show={show} 
                onHide={handleClose}
                placement="start"
                style={{ 
                    backgroundColor: 'rgba(51, 51, 51, 0.98)',
                    backdropFilter: 'blur(20px) saturate(180%)',
                    WebkitBackdropFilter: 'blur(20px) saturate(180%)',
                    borderRight: '1px solid rgba(255, 255, 255, 0.1)'
                }}
            >
                <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title>
                        <img src={logo2} alt="Logo" height="40" />
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column gap-3">
                        {navItems.map((item) => (
                            <Nav.Link 
                                key={item.id}
                                onClick={() => handleNavClick(item.id)}
                                style={{ 
                                    color: 'white', 
                                    fontSize: '18px', 
                                    fontWeight: '500',
                                    padding: '12px 20px',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                                className="mobile-nav-link"
                            >
                                {item.label}
                            </Nav.Link>
                        ))}
                    </Nav>
                    
                   
                    <div className="mt-5 pt-5 border-top border-secondary">
                        <div className="text-white mb-3 d-flex align-items-center">
                            <FaPhone className="me-2" style={{ opacity: 0.7 }} />
                            <div>
                                <small className="d-block opacity-75">Manager</small>
                                <strong>0315-5530667</strong>
                            </div>
                        </div>
                        <div className="text-white d-flex align-items-center">
                            <FaPhone className="me-2" style={{ opacity: 0.7 }} />
                            <div>
                                <small className="d-block opacity-75">Support</small>
                                <strong>0332-9911223</strong>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            <style jsx="true">{`
                /* Hover effect for desktop nav links */
                .nav-link-hover:hover {
                    color: ${colors.SECONDARY} !important;
                    transform: translateY(-2px);
                }
                
                .nav-link-hover:hover .nav-underline {
                    width: 100% !important;
                }
                
                /* Mobile nav link hover effect */
                .mobile-nav-link:hover {
                    background: rgba(255, 255, 255, 0.1) !important;
                    padding-left: 30px !important;
                }
                
                /* Remove default link styling */
                .nav-link {
                    text-decoration: none;
                }
                
                /* Glassmorphism effect enhancement */
                .main-navbar {
                    background: rgba(51, 51, 51, 0.9);
                    -webkit-backdrop-filter: blur(10px) saturate(180%);
                    backdrop-filter: blur(10px) saturate(180%);
                }
                
                .main-navbar.scrolled {
                    background: rgba(51, 51, 51, 0.7);
                }
                
                /* For mobile responsiveness */
                @media (max-width: 768px) {
                    .top-header {
                        padding: 6px 0;
                    }
                    .top-header span {
                        font-size: 12px;
                    }
                }
                
                @media (max-width: 576px) {
                    .top-header {
                        padding: 4px 0;
                    }
                    .top-header span {
                        font-size: 11px;
                    }
                }
                
                /* Smooth transitions */
                * {
                    transition: background-color 0.3s ease, 
                                backdrop-filter 0.3s ease,
                                transform 0.3s ease,
                                opacity 0.3s ease;
                }
            `}</style>
        </>
    );
};

export default Header;